import $ from "jquery";

export const createUploadFilesClickEvent = uploadFiles => () => {
  $('<input type="file" multiple />').bind('change', event => {
    event.preventDefault();
    uploadFiles(event.target.files);
  }).trigger('click');
};
